module.exports = __webpack_public_path__ + "img/level-1.292099c8.png";